const RewriteIconLarger = (props: { color?: string }) => {
    return (
        <svg width="26px" height="20px" viewBox="0 0 26 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>Modify Title</title>
            <g id="PathPilotApp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PPDesktopChatThreadJobBoard1920Copy6" transform="translate(-1275, -61)" stroke={props.color ?? "#000000"} strokeWidth="2">
                    <g id="Group9" transform="translate(1276, 62)">
                        <polygon id="Stroke1" points="12.513273 16.4552453 7 18 8.68563524 12.5920755 20.1723622 1 24 4.86316981"></polygon>
                        <line x1="10" y1="12" x2="13" y2="15" id="Stroke3"></line>
                        <line x1="0" y1="0.5" x2="9" y2="0.5" id="Stroke5"></line>
                        <line x1="0" y1="5.5" x2="6" y2="5.5" id="Stroke7"></line>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default RewriteIconLarger;
